import styled from 'styled-components';
import {
  Table as SemanticTable,
  Button as SemanticButton,
} from 'semantic-ui-react';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  background-color: ${(props) => props.theme.color.white};
  padding: 20px;
  border-radius: 4px;
  height: 95%;
`;

export const Table = styled(SemanticTable)`
  &.ui.celled.table tr td:first-child {
    z-index: 4;
    position: sticky;
    left: 0;
    background-color: white;
  }

  &.ui.table thead tr:first-child>th:first-child {
    z-index: 6;
    top: 0;
    left: 0;
  }
`;

export const TableCellColored = styled(Table.Cell)`
  &&& {
    background-color: ${(props) => props.color} !important; 
  }
  &&&&:hover {
    filter: brightness(0.95);
  }
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ButtonToggle = styled(SemanticButton)`
  &&.ui.button.toggle.active {
    background-color: ${(props) => props.theme.color.toggleBackground} !important;
    color: ${(props) => props.theme.color.toggleTextColor} !important;
  }
`;

export const ContainerTable = styled.div`
  display: flex;
  position: relative;
  overflow: auto;
  max-width: 100%;
  max-height: 100%;
  margin-top: 20px;
  padding: 0 20px 20px 0;
`;
